import { Grid } from '@mui/material';
import { Providers } from '@microsoft/mgt-element';
import * as React from 'react';
import { appInsights } from '../../AppInsights';
import styles from './Layout.module.scss';
import { Login } from '@microsoft/mgt-react';
import logo from '../../assets/img/themis-logo.png';
import { Button, Icon, Menu, Sidebar } from 'semantic-ui-react';
import { IDocumentHistory, ISearchHistory } from '../../intefaces';
import { DataService, IDataService } from '../../services';
import { Footer } from '..';

interface ILayoutProps { }
interface ILayoutState {
    userLogged: boolean;
    visible: boolean;
    searchHistory: ISearchHistory[];
    documentHistory: IDocumentHistory[];
}


export class Layout extends React.Component<ILayoutProps, ILayoutState> {
    private _dataService: IDataService = new DataService();

    constructor(props: ILayoutProps) {
        super(props);
        this.state = {
            userLogged: false,
            visible: false,
            searchHistory: [],
            documentHistory: []
        }
    }

    async componentDidMount() {
        await this.getUserDetails().then(async () => {
            this.setState({
                searchHistory: await this._dataService.CallGetSearchHistory(),
                documentHistory: await this._dataService.CallGetDocumentHistory()
            });
        });
    }

    async componentDidUpdate(prevProps: ILayoutProps, prevState: ILayoutState) {
        if (prevProps != this.props) {
            await this.getUserDetails().then(async () => {
                this.setState({
                    searchHistory: await this._dataService.CallGetSearchHistory(),
                    documentHistory: await this._dataService.CallGetDocumentHistory()
                });
            });
        } 

        if (this.state.userLogged != prevState.userLogged) {
            this.setState({
                searchHistory: await this._dataService.CallGetSearchHistory(),
                documentHistory: await this._dataService.CallGetDocumentHistory()
            });
        }
    }

    private async getUserDetails() {
        try {
            let provider = Providers.globalProvider;
            if (provider) {
                let graphClient = provider.graph.client;
                let userDetails = await graphClient.api('me').get();
                appInsights.trackEvent({ name: 'user logged', properties: { "user details: ": userDetails.userPrincipalName } });

                this.setState({
                    userLogged: true
                })
            } else {
                appInsights.trackEvent({ name: 'user logged State', properties: { "user state is: ": false } });
                this.setState({
                    userLogged: false
                })
            }
        } catch (e) {
            this.setState({ userLogged: false });
        }
    }

    public render() {
        appInsights.trackTrace({
            message: this.state.userLogged? "user logged state is true" : "user logged state is false"       
         });
        return (
            <div className={styles.layout}>
                <div className={styles.main}>
                    <header>
                        <div>
                            <Grid container spacing={1}>
                                <Grid item xs={1} />
                                <Grid item xs={10}>
                                    <div className={styles.header}>
                                        <img src={logo} alt={logo} onClick={() => this.setState({ visible: !this.state.visible })} />
                                        <Login className={styles.login} loginCompleted={() => this.getUserDetails()} />
                                    </div>
                                </Grid>
                                <Grid item xs={1} />
                            </Grid>
                        </div>
                    </header>
                    <div>
                        <Grid container spacing={1}>
                            <Grid item xs={1} />
                            <Grid item xs={10}>
                                {
                                    (this.state.userLogged) ?
                                        <Sidebar.Pushable>
                                            <Sidebar
                                                as={Menu}
                                                animation='overlay'
                                                icon='labeled'
                                                onHide={() => this.setState({ visible: false })}
                                                vertical
                                                visible={this.state.visible}
                                                width='wide'
                                            >
                                                <Menu.Item as='label' onClick={(e) => this.onClick(e, '/')} className={styles.sidebar}>
                                                    <Icon name='home' />
                                                    <h4>Home</h4>
                                                </Menu.Item>
                                                <Menu.Item as='label'>
                                                    <Icon name='list' />
                                                    <h4>Search history</h4>
                                                    <div>
                                                        {this.state.searchHistory !== undefined && this.state.searchHistory.map((history, i) => (
                                                                <Button key={i} onClick={(e) => this.onClick(e, history.searchUrl)} fluid>
                                                                    {history.searchTerm}
                                                                </Button>
                                                        ))}
                                                    </div>
                                                </Menu.Item>
                                                <Menu.Item as='label'>
                                                    <Icon name='file alternate outline' />
                                                    <h4>Viewed documents</h4>
                                                    <div>
                                                        {this.state.searchHistory !== undefined && this.state.documentHistory.map((history, i) => (
                                                                <Button key={i} onClick={(e) => this.onClick(e, history.documentUrl)} fluid>
                                                                    {history.documentTitle}
                                                                </Button>
                                                        ))}
                                                    </div>
                                                </Menu.Item>
                                            </Sidebar>

                                            <Sidebar.Pusher dimmed={this.state.visible}>
                                                <div className={styles.children}>
                                                {this.props.children}
                                                </div>
                                            </Sidebar.Pusher>
                                        </Sidebar.Pushable>

                                        : <div>You need to login to have access to search</div>
                                }
                            </Grid>
                            <Grid item xs={1} />
                        </Grid>
                    </div>
                </div>
                <footer>
                    <Footer />
                </footer>
            </div >
        )
    }

    private onClick(e: any, d: any){
        e.preventDefault();
        window.location.href=d;
    }
}